//import '../img/ayvens-logo.svg';
//(function(e){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],e)}else if(typeof exports!=="undefined"){module.exports=e(require("jquery"))}else{e(jQuery)}})(function(X){X.fn.marquee=function(B){return this.each(function(){var i=X.extend({},X.fn.marquee.defaults,B),a=X(this),r,n,s,o,u,f=3,e="animation-play-state",d=false,l=function(e,t,i){var a=["webkit","moz","MS","o",""];for(var r=0;r<a.length;r++){if(!a[r])t=t.toLowerCase();e.addEventListener(a[r]+t,i,false)}},p=function(e){var t=[];for(var i in e){if(e.hasOwnProperty(i)){t.push(i+":"+e[i])}}t.push();return"{"+t.join(",")+"}"},c=function(){a.timer=setTimeout(A,i.delayBeforeStart)},t={pause:function(){if(d&&i.allowCss3Support){r.css(e,"paused")}else{if(X.fn.pause){r.pause()}}a.data("runningStatus","paused");a.trigger("paused")},resume:function(){if(d&&i.allowCss3Support){r.css(e,"running")}else{if(X.fn.resume){r.resume()}}a.data("runningStatus","resumed");a.trigger("resumed")},toggle:function(){t[a.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout(a.timer);a.find("*").addBack().off();a.html(a.find(".js-marquee:first").html())}};if(typeof B==="string"){if(X.isFunction(t[B])){if(!r){r=a.find(".js-marquee-wrapper")}if(a.data("css3AnimationIsSupported")===true){d=true}t[B]()}return}var m={},g;X.each(i,function(e){g=a.attr("data-"+e);if(typeof g!=="undefined"){switch(g){case"true":g=true;break;case"false":g=false;break}i[e]=g}});if(i.speed){i.duration=parseInt(a.width(),10)/i.speed*1e3}o=i.direction==="up"||i.direction==="down";i.gap=i.duplicated?parseInt(i.gap):0;a.wrapInner('<div class="js-marquee"></div>');var h=a.find(".js-marquee").css({"margin-right":i.gap,float:"left"});if(i.duplicated){if(i.duplicateCount<=0){i.duplicateCount=1}for(let e=0;e<i.duplicateCount;e++){h.clone(true).appendTo(a)}}a.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');r=a.find(".js-marquee-wrapper");if(o){var y=a.height();r.removeAttr("style");a.height(y);a.find(".js-marquee").css({float:"none","margin-bottom":i.gap,"margin-right":0});if(i.duplicated){a.find(".js-marquee:last").css({"margin-bottom":0})}var v=a.find(".js-marquee:first").height()+i.gap;if(i.startVisible&&!i.duplicated){i._completeDuration=(parseInt(v,10)+parseInt(y,10))/parseInt(y,10)*i.duration;i.duration=parseInt(v,10)/parseInt(y,10)*i.duration}else{i.duration=(parseInt(v,10)+parseInt(y,10))/parseInt(y,10)*i.duration}}else{u=a.find(".js-marquee:first").width()+i.gap;n=a.width();if(i.startVisible&&!i.duplicated){i._completeDuration=(parseInt(u,10)+parseInt(n,10))/parseInt(n,10)*i.duration;i.duration=parseInt(u,10)/parseInt(n,10)*i.duration}else{i.duration=(parseInt(u,10)+parseInt(n,10))/parseInt(n,10)*i.duration}}if(i.duplicated){i.duration=i.duration/2}if(i.allowCss3Support){var x=document.body||document.createElement("div"),I="marqueeAnimation-"+Math.floor(Math.random()*1e7),w="Webkit Moz O ms Khtml".split(" "),S="animation",b="",q="";if(x.style.animation!==undefined){q="@keyframes "+I+" ";d=true}if(d===false){for(var j=0;j<w.length;j++){if(x.style[w[j]+"AnimationName"]!==undefined){var C="-"+w[j].toLowerCase()+"-";S=C+S;e=C+e;q="@"+C+"keyframes "+I+" ";d=true;break}}}if(d){b=I+" "+i.duration/1e3+"s "+i.delayBeforeStart/1e3+"s infinite "+i.css3easing;a.data("css3AnimationIsSupported",true)}}var V=function(){r.css("transform","translateY("+(i.direction==="up"?y+"px":"-"+v+"px")+")")},k=function(){r.css("transform","translateX("+(i.direction==="left"?n+"px":"-"+u+"px")+")")};if(i.duplicated){if(o){if(i.startVisible){r.css("transform","translateY(0)")}else{r.css("transform","translateY("+(i.direction==="up"?y+"px":"-"+(v*2-i.gap)+"px")+")")}}else{if(i.startVisible){r.css("transform","translateX(0)")}else{r.css("transform","translateX("+(i.direction==="left"?n+"px":"-"+(u*2-i.gap)+"px")+")")}}if(!i.startVisible){f=1}}else if(i.startVisible){f=2}else{if(o){V()}else{k()}}var A=function(){if(i.duplicated){if(f===1){i._originalDuration=i.duration;if(o){i.duration=i.direction==="up"?i.duration+y/(v/i.duration):i.duration*2}else{i.duration=i.direction==="left"?i.duration+n/(u/i.duration):i.duration*2}if(b){b=I+" "+i.duration/1e3+"s "+i.delayBeforeStart/1e3+"s "+i.css3easing}f++}else if(f===2){i.duration=i._originalDuration;if(b){I=I+"0";q=X.trim(q)+"0 ";b=I+" "+i.duration/1e3+"s 0s infinite "+i.css3easing}f++}}if(o){if(i.duplicated){if(f>2){r.css("transform","translateY("+(i.direction==="up"?0:"-"+v+"px")+")")}s={transform:"translateY("+(i.direction==="up"?"-"+v+"px":0)+")"}}else if(i.startVisible){if(f===2){if(b){b=I+" "+i.duration/1e3+"s "+i.delayBeforeStart/1e3+"s "+i.css3easing}s={transform:"translateY("+(i.direction==="up"?"-"+v+"px":y+"px")+")"};f++}else if(f===3){i.duration=i._completeDuration;if(b){I=I+"0";q=X.trim(q)+"0 ";b=I+" "+i.duration/1e3+"s 0s infinite "+i.css3easing}V()}}else{V();s={transform:"translateY("+(i.direction==="up"?"-"+r.height()+"px":y+"px")+")"}}}else{if(i.duplicated){if(f>2){r.css("transform","translateX("+(i.direction==="left"?0:"-"+u+"px")+")")}s={transform:"translateX("+(i.direction==="left"?"-"+u+"px":0)+")"}}else if(i.startVisible){if(f===2){if(b){b=I+" "+i.duration/1e3+"s "+i.delayBeforeStart/1e3+"s "+i.css3easing}s={transform:"translateX("+(i.direction==="left"?"-"+u+"px":n+"px")+")"};f++}else if(f===3){i.duration=i._completeDuration;if(b){I=I+"0";q=X.trim(q)+"0 ";b=I+" "+i.duration/1e3+"s 0s infinite "+i.css3easing}k()}}else{k();s={transform:"translateX("+(i.direction==="left"?"-"+u+"px":n+"px")+")"}}}a.trigger("beforeStarting");if(d){r.css(S,b);var e=q+" { 100%  "+p(s)+"}",t=r.find("style");if(t.length!==0){t.filter(":last").html(e)}else{X("head").append("<style>"+e+"</style>")}l(r[0],"AnimationIteration",function(){a.trigger("finished")});l(r[0],"AnimationEnd",function(){A();a.trigger("finished")})}else{r.animate(s,i.duration,i.easing,function(){a.trigger("finished");if(i.pauseOnCycle){c()}else{A()}})}a.data("runningStatus","resumed")};a.on("pause",t.pause);a.on("resume",t.resume);if(i.pauseOnHover){a.on("mouseenter",t.pause);a.on("mouseleave",t.resume)}if(d&&i.allowCss3Support){A()}else{c()}})};X.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duplicateCount:1,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    observer.unobserve(entry.target); // Remove if you want it only once
                }
            });
        },
        {
            threshold: 0.8, // 30% visibility
        }
    );

    const h3Element = document.querySelector(".intro h3");
    if (h3Element) {
        observer.observe(h3Element);
    }
});

document.addEventListener('DOMContentLoaded', () => {
  const cols = document.querySelectorAll('.colnumbers .col');
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  const observer = new IntersectionObserver((entries, observer) => {
    let delay = 0;

    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const el = entry.target;

        if (isDesktop) {
          // Stagger animation with delay
          setTimeout(() => {
            el.classList.add('visible');
          }, delay);
          delay += 200; // 200ms between items
        } else {
          el.classList.add('visible');
        }

        observer.unobserve(el);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -25% 0px', // Slight offset to trigger when item is well in view
    threshold: 0.1
  });

  cols.forEach(col => observer.observe(col));
});

document.addEventListener('DOMContentLoaded', function () {
  const cols = document.querySelectorAll('.iconcols .col');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target); // Remove this line if you want animation to trigger again on re-entry
      }
    });
  }, {
    root: null, // Use viewport as root
    rootMargin: '-75% 0px 0px 0px', // Triggers when top of element reaches top 25% of viewport
    threshold: 0
  });

  cols.forEach(col => {
    observer.observe(col);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const cols = document.querySelectorAll('.icon-cols .icon-col');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target); // Remove this line if you want animation to trigger again on re-entry
      }
    });
  }, {
    root: null, // Use viewport as root
    rootMargin: '-90% 0px 0px 0px', // Triggers when top of element reaches top 25% of viewport
    threshold: 0
  });

  cols.forEach(col => {
    observer.observe(col);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const cols = document.querySelectorAll('.blog-line');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        observer.unobserve(entry.target); // Remove this line if you want animation to trigger again on re-entry
      }
    });
  }, {
    root: null, // Use viewport as root
    rootMargin: '-75% 0px 0px 0px', // Triggers when top of element reaches top 25% of viewport
    threshold: 0
  });

  cols.forEach(col => {
    observer.observe(col);
  });
});

/*
document.addEventListener('DOMContentLoaded', function () {
  const results = document.querySelectorAll('.result');
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;
  let animated = new Set(); // Keep track of what's already animated

  // Detect Safari on iOS
  const isIOS = /iP(ad|od|hone)/i.test(navigator.userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const useScrollFallback = isIOS && isSafari;

  // IntersectionObserver setup
  if (!useScrollFallback && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      let delay = 0;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;

          if (isDesktop) {
            setTimeout(() => {
              el.classList.add('open');
            }, delay);
            delay += 200;
          } else {
            el.classList.add('open');
          }

          animated.add(el);
          observer.unobserve(el);
        }
      });
    }, {
      root: null,
      rootMargin: '-75% 0px -50% 0px',
      threshold: 0
    });

    results.forEach(result => {
      observer.observe(result);
    });
  } else {
    // Fallback for iOS Safari
    const handleScrollFallback = () => {
      results.forEach(el => {
        if (animated.has(el)) return;

        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.7) {
          el.classList.add('open');
          animated.add(el);
        }
      });
    };

    window.addEventListener('scroll', handleScrollFallback, { passive: true });
    window.addEventListener('resize', handleScrollFallback);
    handleScrollFallback(); // run on load
  }
});
*/

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate');
    }
  });
}, {
  threshold: 0.5
});


document.addEventListener('DOMContentLoaded', function () {
  const results = document.querySelectorAll('.result');
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;
  const animated = new Set();

  const isIOS = /iP(ad|od|hone)/i.test(navigator.userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const useScrollFallback = isIOS || isSafari;

  let globalDelay = 0;

  function animateIfInView(el) {
    const rect = el.getBoundingClientRect();
    if (
      rect.top < window.innerHeight * 0.8 &&
      rect.bottom > 0 &&
      !animated.has(el)
    ) {
      if (isDesktop) {
        setTimeout(() => el.classList.add('open'), globalDelay);
        globalDelay += 200;
      } else {
        el.classList.add('open');
      }
      animated.add(el);
      return true;
    }
    return false;
  }

  if (!useScrollFallback && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (entry.isIntersecting && !animated.has(el)) {
          if (isDesktop) {
            setTimeout(() => el.classList.add('open'), globalDelay);
            globalDelay += 200;
          } else {
            el.classList.add('open');
          }
          animated.add(el);
          observer.unobserve(el);
        }
      });
    }, {
      root: null,
      threshold: 0.2,
      rootMargin: '0px 0px -20% 0px'
    });

    results.forEach(el => {
      if (!animateIfInView(el)) {
        observer.observe(el);
      }
    });
  } else {
    // Scroll fallback
    const handleScrollFallback = () => {
      results.forEach(el => animateIfInView(el));
    };

    window.addEventListener('scroll', handleScrollFallback, { passive: true });
    window.addEventListener('resize', handleScrollFallback);
    handleScrollFallback();
  }
});

/******** */


const section = document.querySelector('.car-section-wrapper');
if (section) {
  observer.observe(section);
}

let lastScrollTop = 0;
const delta = 10;
const navbar = document.querySelector('.navbar-holder');
let ticking = false;

function handleScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Always show navbar when scrolled to top
  if (scrollTop === 0) {
    navbar.classList.remove('hidden');
    lastScrollTop = 0;
    ticking = false;
    return;
  }

  if (Math.abs(scrollTop - lastScrollTop) > delta) {
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      navbar.classList.add('hidden');
    } else {
      // Scrolling up
      navbar.classList.remove('hidden');
    }

    lastScrollTop = scrollTop;
  }

  ticking = false;
}

window.addEventListener('scroll', function () {
  if (!ticking) {
    window.requestAnimationFrame(handleScroll);
    ticking = true;
  }
});


(function($) {
  'use strict';

  $(window).on('resize', function() {
    if(window.innerWidth > 1307) {
      jQuery('.primary-menu .sw').each(function(){
        //jQuery(this).css('width', 'auto'); // Reset width first
        //let liw = jQuery(this).width() + 40; 
        //jQuery(this).css('width', liw); 
        
      });
      jQuery('.navbar-wrapper ul').width('auto');
    }else{
      jQuery('.primary-menu .sw').each(function(){jQuery(this).css('width', 'auto');});
      //jQuery('.navbar-wrapper ul').width( jQuery('.navbar-wrapper').innerWidth() - 27);
    }
  });

  // Document ready
  $(document).ready(function() {

    if(window.innerWidth > 1307) {
      //jQuery('.primary-menu .sw').each(function(){let liw = jQuery(this).width() + 40; jQuery(this).css('width', liw);});
      jQuery('.navbar-wrapper ul').width('auto');
      
    }else{
      jQuery('.primary-menu .sw').each(function(){jQuery(this).css('width', 'auto');});
      //jQuery('.navbar-wrapper ul').width( jQuery('.navbar-wrapper').innerWidth() - 27);
    }

    $('.slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 600,
      cssEase: 'ease-in-out',
      pauseOnHover: false,
      pauseOnFocus: false,
    });
    /*
    $('.primary-menu a').on('click', function() {
      if($('.toggle-mobile-menu:visible')){
        alert('CLOSE MOBILE MENU');
        $('.toggle-mobile-menu').trigger('click');
      }
    });
    */
    /*
    $('#marquee').marquee(
      {
        //duplicated: true,
      }
    );
    */

    $('#submitquiz').on('click', function(){
      //valiadte email

      var sendok = true;

      var femail = $('.femail').val();

      if(femail){
        $('.error-text.efemail').removeClass('show');
      }else{
        $('.error-text.efemail').addClass('show');
        sendok = false;
      }

      var consent1 = $('.consent1').is(':checked');
      if(consent1){
        $('.consent1-circle').removeClass('error');
      }else{
        $('.consent1-circle').addClass('error');
        sendok = false;
      }
      console.log(consent1);

      if(sendok){
        //alert('SEND FORM');
      }else{
        //alert('Chyba pri odosielaní formulára');
      }
    });

    $('.start-quiz').on('click', function(e){
      e.preventDefault();

      $(this).parent('.quiz-step').hide();
      $('.quiz-step[data-step="1"]').fadeIn();
    });

    $('.quiz .navigation .right').on('click', function (e) {
      e.preventDefault();

      if ($(this).hasClass('active')) {
        const $currentStep = $(this).closest('.quiz-step');
        const myIndex = parseFloat($currentStep.attr('data-step'));
        const nextIndex = myIndex + 1;
        const $nextStep = $('.quiz-step[data-step="' + nextIndex + '"]');

        $currentStep.fadeOut(500, function () {
          $nextStep.fadeIn(500);
        });
      }
    });

    $('.quiz .navigation .left').on('click', function (e) {
      e.preventDefault();

      const $currentStep = $(this).closest('.quiz-step');
      const myIndex = parseFloat($currentStep.attr('data-step'));
      const prevIndex = myIndex - 1;
      const $prevStep = $('.quiz-step[data-step="' + prevIndex + '"]');

      $currentStep.fadeOut(500, function () {
        $prevStep.fadeIn(500);
      });
    });

    $('.radio-group input').on('change', function () {
      const self = this; // capture the input reference

      setTimeout(function () {
        $(self).closest('.quiz-step').find('.navigation .right')
          .removeClass('inactive')
          .addClass('active')
          .trigger('click');
      }, 800);
    });

    $('#marquee').slick({
      //slidesToShow: 10,         // adjust for desktop
      slidesToScroll: 1,
      infinite: true,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 0,        // next tick fires immediately
      speed: 1100,             // bigger = slower drift
      cssEase: 'linear',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,           // no prev/next arrows
      dots: false,             // no pagination dots
      //rtl: true,               // direction: right → left
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 6 } },
        { breakpoint: 576, settings: { slidesToShow: 6 } }
      ]
    });

    

    /*
    $('.quiz-steps').slick({
      slidesToShow: 1,         // adjust for desktop
      slidesToScroll: 1,
      infinite: false,
      variableWidth: true,
      autoplay: false,
      autoplaySpeed: 0,        // next tick fires immediately
      speed: 700,             // bigger = slower drift
      cssEase: 'linear',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: true,           // no prev/next arrows
      dots: false,             // no pagination dots
   
    });
    */

    $('.vcarousel').slick({
      centerMode: true,        // center mode for vertical carousel
      centerPadding: '0%',    // no padding for vertical carousel
      slidesToShow: 3,         // adjust for desktop
      slidesToScroll: 1,
      infinite: true,
      variableWidth: false,
      autoplay: false,
      autoplaySpeed: 3000,        // next tick fires immediately
      speed: 800,             // bigger = slower drift
      cssEase: 'linear',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,           // no prev/next arrows
      dots: false,             // no pagination dots
      vertical: true,          // <-- Make carousel vertical
      //rtl: true,               // direction: right → left
      responsive: [
        { 
            breakpoint: 768, settings: {  
              autoplaySpeed: 2500,
            speed: 400, // Adjust speed for smaller screens
            slidesToShow: 1,
            vertical: false,  // Disable vertical on smaller screens
            centerMode: false, // Disable center mode on smaller screens
            variableWidth: true, // Enable variable width for smaller screens 
            autoplay: false, // Disable autoplay on smaller screens
          } 
      },
      ]
    });

    $('.testimonial-cards').slick({
      centerMode: false,        // center mode for vertical carousel
      centerPadding: '0px',    // no padding for vertical carousel
      slidesToShow: 3,         // adjust for desktop
      slidesToScroll: 1,
      infinite: true,
      variableWidth: true,
      autoplay: false,
      autoplaySpeed: 1500,        // next tick fires immediately
      speed: 700,             // bigger = slower drift
      cssEase: 'linear',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,           // no prev/next arrows
      dots: false,             // no pagination dots
      vertical: false,          // <-- Make carousel vertical
      //rtl: true,               // direction: right → left
      responsive: [
        { 
          breakpoint: 768, settings: { 
            slidesToShow: 1,
            vertical: false,  // Disable vertical on smaller screens
            centerMode: false, // Disable center mode on smaller screens
            variableWidth: true, // Enable variable width for smaller screens 
            autoplay: false, // Disable autoplay on smaller screens
          } 
      },
      ]
    });

    // Custom navigation for testimonial-cards slider
    $('.testimonials .navigation .left').on('click', function(e) {
      e.preventDefault();
      $('.testimonial-cards').slick('slickPrev');
    });

    $('.testimonials .navigation .right').on('click', function(e) {
      e.preventDefault();
      $('.testimonial-cards').slick('slickNext');
    });

    
    
    let vcarouselPlayed = false;

    $(window).on('scroll', function() {
      if (vcarouselPlayed) return;

      var $carousel_wrapp = $('.vertical-carousel');
      var $carousel = $('.vcarousel');
      if ($carousel.length === 0) return;

      var carouselTop = $carousel_wrapp.offset().top;
      var carouselHeight = $carousel_wrapp.outerHeight();
      var scrollBottom = $(window).scrollTop() + $(window).height();

      // Trigger when bottom of carousel is in viewport
      if (scrollBottom >= carouselTop + carouselHeight) { // 130px from top of carousel is visible
        $carousel.slick('slickPlay');
        vcarouselPlayed = true;
      }
    });
    

    // Mobile menu toggle
    $('.menu-toggle').on('click', function() {
      $('.main-navigation').toggleClass('toggled');
    });

    $('.read-more').on('click', function(e) {
      e.preventDefault();
      const content = $('.text-more');
      content.slideToggle(300, function(){});
      $(this).toggle();
    });


    // Smooth scroll for anchor links
    
    $('a[href*="#"]:not([href="#"])').on('click', function() {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        var s_offset = 0;
        if(this.hash.slice(1) == 'ay-patches'){
          s_offset = 120;
        }
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top + s_offset
          }, 1000);
          return false;
        }
      }
    });
    

    // Add active class to current menu item
    /*
    $('.main-navigation a').each(function() {
      if (window.location.href.indexOf($(this).attr('href')) > -1) {
        $(this).addClass('active');
      }
    });
    */
  });
/*
  // Start autoplay when carousel enters viewport
    document.addEventListener('DOMContentLoaded', function() {
      console.log('dddd');
      const vcarousel = document.querySelector('.present-section');
      console.log(vcarousel);
      if (!vcarousel) return;
      console.log(vcarousel);
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            console.log('observujem');
            if (entry.isIntersecting) {
              $('.vcarousel').slick('slickPlay');
              observer.disconnect(); // Remove observer after first trigger
            }
          });
        },
        {
          root: null,
          threshold: 0,
          rootMargin: "130px 0px 0px 0px" // Trigger when 130px of the section is visible
        }
      );

      observer.observe(vcarousel);
    });
*/
  // Mobile menu toggle
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.menu-toggle');
    const primaryMenu = document.querySelector('.primary-menu');
 
    if (menuToggle && primaryMenu) {
      menuToggle.addEventListener('click', function() {
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', !isExpanded);
        primaryMenu.classList.toggle('toggled');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('.toggle-mobile-menu');
    const navbar = document.querySelector('.navbar-wrapper');
    if (toggle && navbar) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        navbar.classList.toggle('menu-open');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
  const primaryMenu = document.querySelector('.primary-menu');
  const navbar = document.querySelector('.navbar-wrapper');
  const menuToggle = document.querySelector('.menu-toggle');

  if (primaryMenu && navbar) {
    const links = primaryMenu.querySelectorAll('a[href^="#"]');

    links.forEach(link => {
      link.addEventListener('click', () => {
        // Close the menu
        primaryMenu.classList.remove('toggled');
        navbar.classList.remove('menu-open');
        if (menuToggle) {
          menuToggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
});

})(jQuery);


// QUIZ HANDLING
document.addEventListener('DOMContentLoaded', function () {
  const submitBtn = document.getElementById('submitquiz');
  const emailInput = document.querySelector('.femail');
  const errorEmail = document.querySelector('.efemail');
  const consent1 = document.querySelector('.consent1');

  submitBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // Disable the button and show loading state
    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading'); // Optional: add a loading class for styling

    const email = emailInput.value.trim();
    const isConsent1Checked = consent1.checked;

    // Reset errors
    errorEmail.style.display = 'none';
    consent1.closest('.check-item').classList.remove('has-error');

    let isValid = true;

    // Validate email
    if (!validateEmail(email)) {
      errorEmail.style.display = 'block';
      isValid = false;
    }

    // Validate required consent
    if (!isConsent1Checked) {
      consent1.closest('.check-item').classList.add('has-error');
      errorEmail.style.display = 'block';
      isValid = false;
    }

    if (!isValid) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-loading');
      return;
    }

    // Collect other quiz answers (example: store them earlier in an object)
    const quizData = collectQuizAnswers(); // you define this elsewhere

    const data = {
      action: 'submit_quiz_to_gf',
      email,
      consent1: isConsent1Checked,
      consent2: document.querySelector('input[name="consent2"]').checked,
      consent3: document.querySelector('input[name="consent3"]').checked,
      answers: quizData
    };

    fetch(window.themeData.ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data)
    })
      .then(res => res.json())
      .then(response => {
        if (response.success) {
          // ✅ Redirect with hash as a query parameter
          console.log(response);
          window.location.href = `/success?hash=${encodeURIComponent(response.data.hash)}`;
        } else {
          alert('Nepodarilo sa odoslať formulár. Skúste znova.');
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
      })
      .catch(() => {
        alert('Chyba pri odosielaní.');
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      });
  });

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function collectQuizAnswers() {
  const answers = [];

  document.querySelectorAll('.quiz-step').forEach((step, index) => {
    const selected = step.querySelector('input[type="radio"]:checked');
    if (selected) {
      answers.push(selected.value);
    } else {
      //answers.push(null); // or '' if you prefer
    }
  });

  return answers;
}
});
// Footer accordion toggle
document.addEventListener('DOMContentLoaded', function () {
  function initFooterAccordion() {
    const columns = document.querySelectorAll('.footer-column');

    if (columns.length === 0) {
      console.warn('No .footer-column elements found.');
      return;
    }

    columns.forEach(column => {
      const button = column.querySelector('.accordion-toggle-wrapper button');
      const content = column.querySelector('.accordion-content');

      if (!button || !content) {
        console.warn('Missing button or accordion content in column:', column);
        return;
      }

      // Initial setup
      if (window.innerWidth < 768) {
        content.style.display = 'none';
        button.setAttribute('aria-expanded', 'false');
      } else {
        content.style.display = 'block';
        button.setAttribute('aria-expanded', 'true');
      }

      // Prevent multiple bindings
      if (button.dataset.accordionBound === 'true') return;
      button.dataset.accordionBound = 'true';

      button.addEventListener('click', function () {
        if (window.innerWidth >= 768) return;

        const expanded = this.getAttribute('aria-expanded') === 'true';

        // Close all other accordions
        columns.forEach(col => {
          const btn = col.querySelector('.accordion-toggle-wrapper button');
          const cnt = col.querySelector('.accordion-content');
          if (btn !== this) {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('rotated');
            cnt.style.display = 'none';
          }
        });

        // Toggle current accordion
        this.setAttribute('aria-expanded', String(!expanded));
        content.style.display = expanded ? 'none' : 'block';
        this.classList.toggle('rotated', !expanded);
      });
    });
  }

  initFooterAccordion();

  // Only re-setup accordions, do not rebind click events
  window.addEventListener('resize', function () {
    const columns = document.querySelectorAll('.footer-column');
    columns.forEach(column => {
      const button = column.querySelector('.accordion-toggle-wrapper button');
      const content = column.querySelector('.accordion-content');
      if (!button || !content) return;
      if (window.innerWidth < 768) {
        content.style.display = 'none';
        button.setAttribute('aria-expanded', 'false');
      } else {
        content.style.display = 'block';
        button.setAttribute('aria-expanded', 'true');
        button.classList.remove('rotated');
      }
    });
  });
});


// ---- Minimal hash re-scroll for Safari/iOS ----
(function () {
  // Tweak if your sticky header changes height
  function headerOffset() {
    const hdr = document.querySelector('.navbar-holder');
    return hdr ? hdr.offsetHeight : 0;
  }

  function scrollToAnchor(id) {
    const el = document.getElementById(id);
    if (!el) return false;

    // Force instant (avoid smooth interactions)
    const top = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset());
    // Temporarily disable smooth behavior if set via CSS
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    requestAnimationFrame(() => {
      window.scrollTo({ top, behavior: 'auto' });
      html.style.scrollBehavior = prev || '';
    });

    return true;
  }

  function settleHash(rawHash) {
    const hash = (rawHash || location.hash || '').replace('#', '');
    if (!hash) return;

    // Try a few times as layout/URL bar settles (0ms, 120ms, 300ms, 600ms)
    const delays = [0, 120, 300, 600];
    delays.forEach((ms) => {
      setTimeout(() => scrollToAnchor(hash), ms);
    });

    // One more after potential viewport resize (iOS address bar)
    let once = false;
    const onResize = () => {
      if (once) return;
      once = true;
      scrollToAnchor(hash);
      window.removeEventListener('resize', onResize);
    };
    window.addEventListener('resize', onResize, { passive: true });
    setTimeout(() => {
      window.removeEventListener('resize', onResize);
    }, 1500);
  }

  // iOS prefers pageshow over load; also handle SPA-ish hash changes
  window.addEventListener('pageshow', () => { if (location.hash) settleHash(); });
  window.addEventListener('hashchange', () => settleHash());

  // Optional: if the page is already interactive and has a hash
  if (document.readyState !== 'loading' && location.hash) settleHash();
  document.addEventListener('DOMContentLoaded', () => { if (location.hash) settleHash(); });
})();